import { Capacitor } from "@capacitor/core";
import { useEffect, useState } from "react";

const mobileQuery = "(max-width: 820px), (pointer: coarse)";

const detectLayout = () => {
	if (Capacitor.isNativePlatform()) return "mobile";
	if (typeof window === "undefined") return "web";
	return window.matchMedia(mobileQuery).matches ? "mobile" : "web";
};

export function usePlatformLayout() {
	const [layoutMode, setLayoutMode] = useState(() => detectLayout());

	useEffect(() => {
		const query = window.matchMedia(mobileQuery);
		const update = () => setLayoutMode(detectLayout());
		query.addEventListener("change", update);
		window.addEventListener("resize", update);
		update();

		return () => {
			query.removeEventListener("change", update);
			window.removeEventListener("resize", update);
		};
	}, []);

	return layoutMode;
}
